import { Link } from "react-router-dom";
import { fmtEUR } from "../lib/auth";
import { useDepots } from "./data";
import type { WidgetComponentProps } from "./registry";

export default function DepotWidget(_props: WidgetComponentProps) {
  const depots = useDepots();
  if (!depots) return null;
  const total = depots.reduce((s, d) => s + Number(d.total_value), 0);
  return (
    <section className="card p-5">
      <div className="flex items-baseline justify-between mb-2">
        <h2 className="section-title">Depots</h2>
        <Link to="/depot" className="text-xs text-brand-300 hover:underline">
          Detail →
        </Link>
      </div>
      {depots.length === 0 ? (
        <p className="text-sm text-ink-400">
          Noch kein Depot. Unter <Link to="/depot" className="text-brand-300 hover:underline">Depot</Link> anlegen.
        </p>
      ) : (
        <>
          <div className="flex items-baseline gap-2">
            <span className="text-2xl font-semibold num text-ink-50">{fmtEUR(total)}</span>
            <span className="text-xs text-ink-400">Gesamtwert aller Depots</span>
          </div>
          <ul className="mt-3 space-y-1.5">
            {depots.map((d) => (
              <li key={d.id} className="flex items-center gap-2 text-sm min-w-0">
                <span className="truncate text-ink-300 flex-1">{d.name}</span>
                <span className="text-[11px] text-ink-500 shrink-0">
                  {d.holdings_count} Pos.
                </span>
                <span className="num text-ink-100 shrink-0">{fmtEUR(d.total_value)}</span>
              </li>
            ))}
          </ul>
        </>
      )}
    </section>
  );
}
